import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";

export interface IGlobalSpinnerState {
    isLoading: boolean;
    loadingMessage: string;
}

const initialGlobalSpinnerState: IGlobalSpinnerState = {
    isLoading: false,
    loadingMessage: 'Please wait...'
};

export const GlobalSpinnerStore = signalStore(
    { providedIn: 'root' },
    withState(initialGlobalSpinnerState),
    withMethods((store) => ({
        show: (message: string = 'Please wait...') => {
            patchState(store, { isLoading: true, loadingMessage: message });
        },
        hide: () => {
            patchState(store, { isLoading: false, loadingMessage: 'Please wait...' });
        }
    }))
);
